import styled from '@emotion/styled';
import { Button } from 'antd';

export const StyledButton = styled(Button)`
  width: 100% !important;
`;
